import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useState } from 'react'
import InView from 'react-intersection-observer'
import BarChart from '../BarChart'

import * as styles from './styles.module.scss'
import * as chartStyles from '../BarChart/styles.module.scss'

const Turnovers: React.FC = () => {
	const [showTurnoversChart, setShowTurnoversChart] = useState(false)
	const [showPurchasedChart, setShowPurchasedChart] = useState(false)
	const { t, i18n } = useTranslation()

	return (
		<section>
			<div className="container">
				<InView onChange={(inView) => inView && setShowTurnoversChart(true)}>
					<div className="row align-items-center">
						<div className="col-md-6 my-5">
							<h2 className="text-center text-md-start mb-4">
								{t('turnovers.turnover.title')}
							</h2>
							<p>
								<Trans
									i18nKey="turnovers.turnover.text1"
									components={[<strong className="text-primary text-nowrap" />]}
								/>
							</p>
							<p>
								<strong>{t('turnovers.turnover.text2')}</strong>
							</p>
						</div>
						<div className="col-md-6 mt-5 mb-3">
							<div className="p-lg-5">
								<div className={chartStyles.chartPlaceholder}>
									{showTurnoversChart && (
										<BarChart
											formatter={(value) => {
												return `€${value / 1000000} mil.`
											}}
											data={[
												{
													category: '2018',
													value: 330000000,
													label: '8,4 mld.'
												},
												{
													category: '2019',
													value: 383000000,
													label: '9,8 mld.'
												},
												{
													category: '2020',
													value: 545000000,
													label: '14,5 mld.'
												},
												{
													category: '2021',
													value: 737000000,
													label: '18 mld.'
												}
											]}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
				</InView>

				<InView onChange={(inView) => inView && setShowPurchasedChart(true)}>
					<div className="row align-items-center">
						<div className="col-md-6 my-5 order-0 order-md-1">
							<h2 className="text-center text-md-start mb-4">
								{t('turnovers.purchased.title')}
							</h2>
							<p>
								<Trans
									i18nKey="turnovers.purchased.text"
									components={[<strong className="text-primary text-nowrap" />]}
								/>
							</p>
						</div>
						<div className="col-md-6 my-3">
							<div className="p-lg-5">
								<div className={chartStyles.chartPlaceholder}>
									{showPurchasedChart && (
										<BarChart
											data={[
												{
													category: '2018',
													value: 29000000,
													label: '29 mil.'
												},
												{
													category: '2019',
													value: 35000000,
													label: '35 mil.'
												},
												{
													category: '2020',
													value: 55000000,
													label: '55 mil.'
												},
												{
													category: '2021',
													value: 77000000,
													label: '77 mil.'
												}
											]}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
				</InView>
			</div>
		</section>
	)
}

export default Turnovers
